<template lang='pug'>
  .signatures
    .box.mt-4
      .text-right
        .search-box.mr-2
          input.form-control(type='text' placeholder='Nime filter'
            v-model='nameFilter' v-on:keyup.enter='refreshTable'
            v-on:keyup.esc='clearFilter')
          b-btn.search(variant='primary' @click='refreshTable')
            font-awesome-icon(icon='search')
          b-btn.clear(variant='primary' @click='clearFilter')
            font-awesome-icon(icon='backspace')

        b-form-select.campaign-select.mr-2(
          v-model='selectedCampaign' :options='campaigns')

        b-btn(variant='primary' @click='removeSignatures' :disabled='selectedItems.length === 0')
          font-awesome-icon(icon='trash-alt').mr-2
          | Kustuta

      //- Table
      b-table.mt-3(
        :items='signaturesProvider'
        :fields='fields'
        :per-page='rowsPerPage'
        :current-page='currentPage'
        ref='signaturesTable'
        hover
        striped
        small
        responsive
      )
        template(v-slot:cell(change)='data')
          .form-group.form-check.text-center
            input.form-check-input(
              type='checkbox' :id="'checkbox' + data.index"
              v-model='data.item.selected')
        template(v-slot:cell(newsletter)='data')
          | {{ data.value ? 'Jah' : 'Ei' }}

        template(v-slot:cell(date)='data')
          | {{ formatDate(data.value) }}

        template(v-slot:cell(utm)='data')
          UtmPopup(
            :rowId='data.item.id'
            :utmTags='data.item'
          )

      //- Pagination
      b-pagination(align='center' :total-rows='totalRows'
        :per-page='rowsPerPage' v-model='currentPage')

      //- Confirm remove modal
      b-modal(ref='removeModal')
        | Oled kindel, et soovid kustutada järgnevate isikute allkirjad?
        ul.mt-3
          li(v-for='item in selectedItems')
            | {{ item.first_name }} {{ item.last_name }}

        template(slot='modal-header')
          h4 Kinnita
        template(slot='modal-footer')
          b-btn(variant='primary' @click='removeModalYes')
            font-awesome-icon(icon='check-circle').mr-2
            | Jah
          b-btn(variant='primary' @click='removeModalNo')
            font-awesome-icon(icon='times-circle').mr-2
            | Ei
</template>

<script>
import { authBackend, formatDate } from '../api'
import UtmPopup from '../components/UtmPopup.vue'

const rowsPerPage = 20

const fields = [
  { key: 'change',
    label: 'Muuda'
  },
  { key: 'first_name',
    label: 'Eesnimi'
  },
  { key: 'last_name',
    label: 'Perekonnanimi'
  },
  { key: 'email',
    label: 'E-post'
  },
  { key: 'phone',
    label: 'Telefon'
  },
  { key: 'newsletter',
    label: 'Uudiskiri'
  },
  { key: 'campaign',
    label: 'Kampaania'
  },
  { key: 'date',
    label: 'Kuupäev'
  },
  {
    key: 'utm',
    label: 'UTM'
  }
]

export default {
  name: 'signatures',

  components: { UtmPopup },

  data() {
    return {
      fields,
      campaigns: [],
      currentPage: 1,
      rowsPerPage,
      totalRows: 0,
      selectedCampaign: 'Kõik',
      nameFilter: '',
      signatures: []
    }
  },

  async created() {
    const campaignNames = (await authBackend().get('/api/signature/campaigns')).data
    campaignNames.unshift('Kõik')

    const campaigns = []
    for (const name of campaignNames) {
      campaigns.push({
        value: name,
        text: name
      })
    }

    this.campaigns = campaigns
  },

  methods: {
    formatDate,

    async fetchSignatures() {
      const cleanedNameFilter = this.nameFilter.replace(/\t/g, ' ')
      const signatures = (
        await authBackend().post('/api/signature', {
          page: this.currentPage - 1,
          campaign: this.selectedCampaign,
          nameFilter: cleanedNameFilter
        })
      ).data
      this.totalRows = signatures.totalRows
      const sigs = signatures.signatures

      for (const sig of sigs) {
        sig.selected = false
      }

      this.signatures = sigs

      return sigs
    },

    signaturesProvider(ctx, callback) {
      this.fetchSignatures().then(callback)
    },

    refreshTable() {
      this.$refs.signaturesTable.refresh()
    },

    clearFilter() {
      this.nameFilter = ''
      this.refreshTable()
    },

    async removeModalYes() {
      this.$refs.removeModal.hide()
      for (const sig of this.selectedItems) {
        await authBackend().delete('/api/signature/id/' + sig.id)
      }
      this.refreshTable()
    },

    removeModalNo() {
      this.$refs.removeModal.hide()
    },

    removeSignatures() {
      this.$refs.removeModal.show()
    }
  },

  watch: {
    selectedCampaign: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.refreshTable()
      }
    }
  },

  computed: {
    selectedItems: function() {
      return this.signatures.filter(item => item.selected)
    }
  }
}
</script>

<style lang="scss">
.signatures .search-box {
  display: inline-block;
  margin-right: 8px;

  input {
    display: inline-block;
    width: 200px;
    border-radius: 4px 0 0 4px;
    padding-top: 4px;
  }

  .btn {
    height: 38px;
  }

  .search {
    border-radius: 0;
  }

  .clear {
    border-radius: 0 4px 4px 0;
  }
}

.signatures .campaign-select {
  display: inline-block;
  width: 250px;
}
</style>
